import { trackEvent } from '@modules/tracking/tracking.js'

if (document.querySelector('.error-page')) {
    trackEvent('Page', {
        category: 'Error',
        label: '404',
        nonInteraction: true,
    })
}
